// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"399f2b8f","188":"b8baecb1","262":"1ab38816","452":"270faee0","555":"ed9372fe","568":"31bd1283","592":"f854b61f","702":"4d3f7e24","729":"425cec19","772":"bf74f964","850":"d3eef9cb","937":"42a64285"}[chunkId] + ".chunk.js";
};